import { DocumentTypeWithVirtual, ValueOf } from 'support/types';

export const hasSummary = (documentType: ValueOf<DocumentTypeWithVirtual> | undefined): boolean => {
  if (!documentType) {
    return false;
  }
  switch (documentType) {
    case DocumentTypeWithVirtual.orderResponse:
    case DocumentTypeWithVirtual.orderRejection:
    case DocumentTypeWithVirtual.orderConfirmation:
    case DocumentTypeWithVirtual.partialOrderConfirmation:
    case DocumentTypeWithVirtual.order:
    case DocumentTypeWithVirtual.dispatchInstruction:
    case DocumentTypeWithVirtual.shippingNotice:
    case DocumentTypeWithVirtual.invoice:
    case DocumentTypeWithVirtual.creditNote:
    case DocumentTypeWithVirtual.productCatalog:
    case DocumentTypeWithVirtual.remittanceAdvice:
    case DocumentTypeWithVirtual.debitNote:
    case DocumentTypeWithVirtual.serviceInvoice:
    case DocumentTypeWithVirtual.salesReport:
      return true;
    case DocumentTypeWithVirtual.dispatchResponse:
    case DocumentTypeWithVirtual.unknown:
    case DocumentTypeWithVirtual.receivalNotice:
    case DocumentTypeWithVirtual.acknowledgement:
    case DocumentTypeWithVirtual.quote:
    default:
      return false;
  }
};
